var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.302px",
    height: "21.302px",
    viewBox: "0 0 33.302 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27597",
    "data-name": "Group 27597",
    transform: "translate(-1248.722 -92.054) rotate(-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27593",
    "data-name": "Group 27593",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 1149.769, 500.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152215",
    "data-name": "Path 152215",
    d: "M0,5.708A12.258,12.258,0,0,1,1.015,4.321,15.548,15.548,0,0,1,5.989.675c4.05-1.748,15.677-1,15.438,13.342",
    transform: "matrix(0.982, -0.191, 0.191, 0.982, 0, 4.089)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27590",
    "data-name": "Group 27590",
    transform: "translate(18.104 10.695) rotate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152217",
    "data-name": "Path 152217",
    d: "M4.506,4.459,0,0",
    transform: "translate(0 0.308)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152218",
    "data-name": "Path 152218",
    d: "M0,5.07H0L3.436,0",
    transform: "translate(6.346 0) rotate(21)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27596",
    "data-name": "Group 27596",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 1145.034, 510.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152215-2",
    "data-name": "Path 152215",
    d: "M0,5.708A12.257,12.257,0,0,1,1.015,4.321,15.548,15.548,0,0,1,5.989.675c4.05-1.748,15.677-1,15.438,13.342",
    transform: "translate(28.395 13.76) rotate(169)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27590-2",
    "data-name": "Group 27590",
    transform: "translate(10.291 7.154) rotate(172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152217-2",
    "data-name": "Path 152217",
    d: "M4.506,4.459,0,0",
    transform: "translate(0 0.308)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152218-2",
    "data-name": "Path 152218",
    d: "M0,5.07H0L3.436,0",
    transform: "translate(6.346 0) rotate(21)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/Recurring.a90bc479a9967f66d4fb2e751d907505.svg";
export { ForwardRef as ReactComponent };